module.exports = __webpack_public_path__ + "static/media/place_students_subscription_missing.4134d6f3.png";